import { useState, useRef, useEffect } from "react";
import { GuidelinePanel } from "./guideline-panel";
import IcSend from "@/assets/icons/ic-send.svg";
import IcSendDisable from "@/assets/icons/ic-send-disable.svg";

interface ChatInputProps {
  onSend: (content: string) => void;
  disabled: boolean;
}

export function ChatInput({ onSend, disabled }: ChatInputProps) {
  const [value, setValue] = useState("");
  const [guidelineExpanded, setGuidelineExpanded] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue("");
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="flex w-full flex-col items-center gap-4 lg:w-[852px]">
      <div className="flex w-full flex-col justify-center gap-12 rounded border border-black/[0.09] bg-white px-2 pb-2 pt-5 shadow-[0px_4px_20px_-8px_rgba(0,0,0,0.09),0px_0px_32px_rgba(0,0,0,0.07)]">
        <div className="flex items-center gap-[10px] px-3">
          <textarea
            ref={textareaRef}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="작성중인 요청사항..."
            rows={1}
            className="w-full max-h-[300px] resize-none bg-transparent text-base font-normal leading-6 tracking-[-0.01em] text-[#000000] placeholder:text-[#BBBBBB] outline-none"
          />
        </div>

        <div className="flex items-end justify-between">
          <GuidelinePanel
            expanded={guidelineExpanded}
            onToggle={() => setGuidelineExpanded(!guidelineExpanded)}
          />

          <div className="flex items-center justify-end">
            <button
              type="button"
              onClick={handleSend}
              disabled={!value.trim() || disabled}
              className="flex h-8 w-8  items-center justify-center rounded-[4px] bg-[#FFAA72] text-black disabled:bg-[#E0E0E0]  "
            >
              <img src={(!value.trim() || disabled) ? IcSendDisable : IcSend} alt="send" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
